import { MessageSquareIcon } from "lucide-react";

import { useChatWidgetContext } from "../context";

import DrawerEmptyState from "@/components/Playground/Drawer/DrawerEmptyState";
import { cn } from "@/lib/utils";

export const ChatEmptyState = () => {
  const { isContainerSizeSmall } = useChatWidgetContext();

  return (
    <DrawerEmptyState
      className={cn("flex-1", isContainerSizeSmall && "px-4 py-4")}
      icon={<MessageSquareIcon />}
      title="No messages yet"
      description="Send a message to start the conversation."
    />
  );
};
